var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MediaQueryProvider',{attrs:{"queries":_vm.mediaQueries}},[_c('div',{staticClass:"gotmehookd-app"},[_c(_vm.layout,{tag:"component",class:_vm.layoutClass},[_c('router-view')],1),_c('modal-container')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }